import { useQuery } from '@tanstack/react-query';
import { api } from '../../api';
import { EXPRESS_POLL_MS } from './lib.js';

export const expressKeys = {
  monitor: ['ops', 'express'] as const,
};

/** GET /ops/express (OpsExpress), every 10 s. */
export function useOpsExpress() {
  return useQuery({ queryKey: expressKeys.monitor, queryFn: () => api.opsExpress(), refetchInterval: EXPRESS_POLL_MS });
}
